/**
 *
 * @page 用户中心/装修方案/我的方案/方案详情页
 *
 **/

import DesignBrief from '@/components/DesignBrief';
import DesignDetail from '@/components/DesignDetail';
import { Spin } from 'antd';
import { getProjecDetail } from '@/api/personCenter/decorationManage';
import './DecorationDesign.scss';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';

export default function DecorationDesign(props) {
    const { pathname } = useLocation();
    const projectVId = +new URLSearchParams(props.location.search).get(
        'projectId'
    );

    const [single, setSingle] = useState(false);
    const [state, setState] = useState({
        detail: {},
        house: {},
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (pathname === '/decoration-design') {
            setSingle(true);
        } else {
            setSingle(false);
        }
    }, [pathname]);

    useEffect(() => {
        setLoading(true);
        getProjecDetail({ projectVId, div: 2 })
            .then(res => {
                const { data, msg, code } = res;
                if (code === 0) {
                    setLoading(false);
                    setState({
                        detail: data.detail,
                        house: data.house,
                    });
                } else {
                    setLoading(false);
                    throw msg;
                }
            })
            .catch(err => {
                setLoading(false);
                throw err;
            });
    }, []);

    return (
        <Spin spinning={loading}>
            <div className={`design-container ${single ? 'single' : ''}`}>
                <DesignBrief
                    projectId={projectVId}
                    detail={state.detail}></DesignBrief>
                <DesignDetail
                    house={state.house}
                    shareLink={state.detail.shareLink}
                    projectId={projectVId}></DesignDetail>
            </div>
        </Spin>
    );
}
